import React from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import { useNavigate } from "react-router-dom";

function SerieFields({ values, handleChange, handleSubmit, errors, touched }) {
  const navigate = useNavigate();

  return (
    <Form noValidate>
      <Row className="mb-3">
        <Form.Group as={Col} md="6" controlId="serieContado">
          <Form.Label>Serie Contado</Form.Label>
          <Form.Control
            type="text"
            name="serieContado"
            placeholder="Serie contado"
            value={values.serieContado}
            onChange={handleChange}
            isInvalid={!!errors.serieContado && touched.serieContado}
            autoComplete="off"
          />
          <Form.Control.Feedback type="invalid">
            {errors.serieContado}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group as={Col} md="6" controlId="serieCredito">
          <Form.Label>Serie Crédito</Form.Label>
          <Form.Control
            type="text"
            name="serieCredito"
            placeholder="Serie crédito"
            value={values.serieCredito}
            onChange={handleChange}
            isInvalid={!!errors.serieCredito && touched.serieCredito}
            autoComplete="off"
          />
          <Form.Control.Feedback type="invalid">
            {errors.serieCredito}
          </Form.Control.Feedback>
        </Form.Group>
      </Row>

      <div className="d-flex justify-content-end gap-2 mt-3">
        <button
          type="button"
          className="btn btn-secondary"
          onClick={() => navigate("/")}
        >
          Cancelar
        </button>

        <button
          type="button"
          className="btn btn-primary"
          onClick={handleSubmit}
        >
          Guardar
        </button>
      </div>
    </Form>
  );
}

export default SerieFields;
